import { render, staticRenderFns } from "./ListaRealizadoPor.vue?vue&type=template&id=ecd94010&"
import script from "./ListaRealizadoPor.vue?vue&type=script&lang=js&"
export * from "./ListaRealizadoPor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports